/**
 * Cart-drawer scrim (Made in Matcha).
 *
 * On wide viewports the cart drawer is a NON-modal dialog that overlays the page (see the
 * overlay override in custom.css), so it has no native `::backdrop`. This adds one: a 40%
 * dark overlay that fades in behind the cart drawer and closes it when clicked.
 *
 * Below the modal breakpoint the drawer is a native modal with its own `::backdrop`
 * (styled in custom.css), so the scrim is only used in overlay mode to avoid double-dimming.
 *
 * Loaded globally from snippets/custom.globals.liquid — zero vendor edit.
 */
const MODAL_BREAKPOINT = 990;
const CART_DRAWER_ID = 'cart-drawer';
const overlayQuery = window.matchMedia(`(min-width: ${MODAL_BREAKPOINT}px)`);

/** @type {HTMLDivElement | null} */
let scrim = null;

function cartDrawer() {
  return document.getElementById(CART_DRAWER_ID);
}

function cartDrawerOpen() {
  return cartDrawer()?.hasAttribute('open') ?? false;
}

function getScrim() {
  if (!scrim) {
    scrim = document.createElement('div');
    scrim.className = 'cart-drawer-scrim';
    // Clicking the scrim (anywhere outside the drawer) closes the cart drawer.
    scrim.addEventListener('click', () => {
      /** @type {any} */ (cartDrawer())?.close?.();
    });
    document.body.appendChild(scrim);
  }
  return scrim;
}

function showScrim() {
  const el = getScrim();
  // Force a reflow so the opacity transition runs from 0 on the frame we add the class.
  void el.offsetWidth;
  el.classList.add('is-visible');
}

function hideScrim() {
  scrim?.classList.remove('is-visible');
}

function isCartDrawerEvent(event) {
  const target = event.target;
  return target instanceof Element && (target.id === CART_DRAWER_ID || target.closest?.(`#${CART_DRAWER_ID}`));
}

document.addEventListener('theme-drawer:open', (event) => {
  if (!isCartDrawerEvent(event)) return;
  if (overlayQuery.matches) showScrim();
});

document.addEventListener('theme-drawer:close', (event) => {
  if (!isCartDrawerEvent(event)) return;
  hideScrim();
});

// Crossing the breakpoint while the cart drawer is open: in overlay mode it needs the scrim;
// in modal mode the native ::backdrop takes over, so drop ours to avoid double-dimming.
overlayQuery.addEventListener('change', () => {
  if (!cartDrawerOpen()) return hideScrim();
  overlayQuery.matches ? showScrim() : hideScrim();
});

// The drawer can be restored already-open after a navigation (via a synchronous script that
// sets [open] before modules load, so `theme-drawer:open` never fired) — cover that on load.
if (cartDrawerOpen() && overlayQuery.matches) showScrim();
